import { Box, Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LouiseOffer } from '../../../../../../../../types/Quotes';
import { addToComparisonMatrix } from '../../../../../store/redux/slices/offersSlice';
import { useLouiseDispatch } from '../../../../../store/redux/store';
import OfferAction from './OfferAction';

interface Props {
  offer: LouiseOffer;
  isDisabled?: boolean;
}

const OfferCompareAction: React.FC<Props> = ({ offer, isDisabled }) => {
  const { t } = useTranslation();
  const dispatch = useLouiseDispatch();

  const handleToggleCompare = () => {
    dispatch(
      addToComparisonMatrix({
        riskObject: offer.info.insurance_type,
        offer,
      }),
    );
  };
  if (isDisabled) return <Box bg="white" />;

  return (
    <OfferAction
      icon={<Icon name="GeneralActionsCompare" />}
      onClick={handleToggleCompare}
      isDisabled={isDisabled}
    >
      {t('COMPARE')}
    </OfferAction>
  );
};

export default OfferCompareAction;
